import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import ToolTipWrapper from '../Tooltip/ToolTipWrapper';

const LockerNotEnabledError = ({isLockerEnabled, isOrgAdmin}:{isLockerEnabled: boolean, isOrgAdmin: boolean}) => {
    
    function GetError(): JSX.Element {
        if(!isLockerEnabled) {
            return (
                <div>
                    <h3>Locker is not enabled for this organisation.</h3>
                    <p>Please contact a system administrator if you wish to enable the locker feature for your organisation</p>
                </div>
            )
        }
        else if(!isOrgAdmin) {
            return (
               <div>
                    <h3>You are not authorised to access Locker Management</h3>
                    <p>Only organisation administrators have permission to manage locker files. If you feel you are seeing this message in error please contact a system administrator.</p>
               </div>
            )
        }
        else return <></>
    }
    
    return (
        <div id="locker-management">
            <section id="locker-manangement-container">
                <main id="locker-management-main" className='locker-disabled'>
                    <div className="locker-management-header">
                        <h1>Locker Management</h1>
                        <ToolTipWrapper id="highlight-tooltip-locker-management" className="tracks-side-tooltip">
                            <ReactTooltip id="highlight-tooltip-locker-management" place="top" className='thrive-tooltip' delayHide={1000} >
                                View and manage Locker files and Locker events for your organisation
                                <button>Learn More</button>
                            </ReactTooltip>
                        </ToolTipWrapper>
                    </div>
                    <GetError />
                    <div>
                        <a className="btn btn-blue" href="../../" style={{marginTop: '15px', cursor:'pointer'}}>Return to your AppLibrary</a>
                    </div>
                </main>
            </section>
        </div>
    )
}

export default LockerNotEnabledError